// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"65":"chart","302":"pediatric","530":"curation","853":"table"}[chunkId] || chunkId) + "." + {"65":"ffeaf664db8ac1b1772f","190":"869ae6f5a80d3d476b0d","298":"f6b88d22ad8709c97878","302":"4b1c4f618228a606f828","530":"b79aefc53f1e9eb1a695","853":"e0b553a6af1a03e3bc51"}[chunkId] + ".css";
};